
//  Link media
require.context('../media/', true, /^\.\/.*\.*/);
require.context('../fonts/', true, /^\.\/.*\.*/);

//  Styles
import '../styles/styles.scss';

// JS
import $ from 'jquery';

// Swiper JS
import Swiper, { Navigation, Pagination } from 'swiper';
// Swiper styles
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

import utils from './proj/utils';
import handleLazySizes from './proj/handleLazySizes';
import handleContainSizing from './proj/handleContainSizing';

import Headroom from "headroom.js";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let Site;
const isMobileDevice = utils.mobileAndTabletCheck();
const isMobile = window.innerWidth < 800 || isMobileDevice;

(function ($) {
	'use strict';

	Site = {
		/**
		 * initialize prototype
		 *
		 */
		init: function (elt) {
			var self = this;

			setTimeout(function(){
				$('#app').addClass('page-ready');
			}, 100);


			// ONLY FOR LOCALHOST until script fixed // || location.hostname === "development.turnercommercialproductions.com"
			if (location.hostname === "localhost" || location.hostname === "127.0.0.1" ) {
				var barEl = document.getElementById('cnn-header');
				if(barEl) {
					self.navshare();
				}
			}

			self.serieStickyMenu();
			self.heroBlur();
			self.illustrations();
			self.countUpNumbers();
			self.newWindowLink();
			// self.lazySizes();
			self.sliderSwipper();

			// self.scrollToAnchor();

			// select your header or whatever element you wish
			if(isMobile) {

				const header = document.getElementById("sticky-menu");
				const headroom = new Headroom(header, {
					  "offset": 60,
					  "tolerance": 0
					});
				headroom.init();
			}
			else {
				// // to destroy
				// headroom.destroy();

				ScrollTrigger.create({
					trigger: '.wrapper-article',
					pin: '#sticky-menu',
					pinSpacing: false,
					start: "top 30px",
					// end: "bottom bottom",
					// animation: gsap.to($(panel).find('img'), { y: '20%' })
				});


				ScrollTrigger.create({
					trigger: '.end-cta',
					start: "bottom bottom",
					end: "bottom top",
					onEnter: function(){
						$('.js-sticky-menu').addClass('is-hidden');
					},
					onLeaveBack: function(){
						$('.js-sticky-menu').removeClass('is-hidden');
					},

					// end: "bottom bottom",
					// animation: gsap.to($(panel).find('img'), { y: '20%' })
				});

			}

			window.addEventListener("resize", utils.debounce(function(e){
				
			}));

		},

		countUpNumbers: function (section) {
			function numberWithCommas(x) {
				return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			}
		
			function animateState(el){
				const count = $(el);
				const comma = $(el).data('comma') || true;
				const countUpDuration = $(el).attr('data-duration') || 1;
				const increment = parseFloat($(el).attr('data-increment')) || 1;
		
				gsap.to(count, {
					innerText: count.attr("data-number"),
					snap: {innerText: increment},
					stagger: {
						each: 1,
						onUpdate: function() {
							if(comma) {
								this.targets()[0].innerHTML = numberWithCommas(this.targets()[0].innerText);
							}
						},
					},
					duration: countUpDuration
				});
		
			}
	
			$('.js-stat-number').each(function(el){

				const $el = $(this);

				ScrollTrigger.create({
					trigger: $el, 
					// markers: true,
					// id: "inview",
					start: "top 95%",
					onEnter: function(){
						// $('.js-stat-number').html(0);
						if (!$el.hasClass('is-inview')) {
							setTimeout(function(){
								animateState($el);
							}, 800);
							$el.addClass('is-inview');
						}
					},
					// onEnterBack: function(){
					// 	$('.js-stat-number').html(0);
					// 	animateState($el);
					// }
				});
				
			});
		
		},

		illustrations: function(){
			if($('.article1_ch1').length > 0) {

				gsap.set('.illustration .i-base, .illustration .i-layer', {opacity: 0});
				
				gsap.set($('.illustration1').parents('.ch1_stat').find('.copy'), {opacity: 0, yPercent: 10});
				gsap.set($('.illustration1').parents('.ch1_stat').find('.txt-source'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration1",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					// once: true,
					animation: gsap.timeline().to($('.illustration1 .l1'), { yPercent: 5, duration: 1 })
							.to($('.illustration1 .l4'), { yPercent: -25, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration1 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration1 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration1 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration1 .l4'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration1').parents('.ch1_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
						.to($('.illustration1').parents('.ch1_stat').find('.txt-source'), { opacity: 1, yPercent: 0, duration: 0.5 }, '<')
					}
				});

				gsap.set($('.illustration2').parents('.ch1_stat').find('.copy'), {opacity: 0, yPercent: 10});
				gsap.set($('.illustration2').parents('.ch1_stat').find('.txt-source'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration2",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					// once: true,
					animation: gsap.timeline().to($('.illustration2 .l1'), { yPercent: -10, duration: 1 })
							.to($('.illustration2 .l3'), { yPercent: -20, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration2 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration2 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration2 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration2').parents('.ch1_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
						.to($('.illustration2').parents('.ch1_stat').find('.txt-source'), { opacity: 1, yPercent: 0, duration: 0.5 }, '<')
					}
				});

				gsap.set($('.illustration3').parents('.ch1_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration3",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					// once: true,
					animation: gsap.timeline().to($('.illustration3 .l2'), { yPercent: -10, duration: 1 })
							.to($('.illustration3 .l1'), { yPercent: -5, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration3 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration3 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration3 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration3').parents('.ch1_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
						
					}
				});

				gsap.set($('.illustration4').parents('.ch1_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration4",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					// once: true,
					animation: gsap.timeline().to($('.illustration4 .l1'), { yPercent: -2, duration: 1 })
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration4 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration4 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration4 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration4 .l4'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration4').parents('.ch1_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
					}
				});

				gsap.set($('.illustration5').parents('.ch1_stat').find('.copy'), {opacity: 0, yPercent: 10});
				gsap.set($('.illustration5').parents('.ch1_stat').find('.txt-source'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration5",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					// once: true,
					animation: gsap.timeline().to($('.illustration5 .l1'), { yPercent: -10, duration: 1 })
							.to($('.illustration5 .l2'), { yPercent: -5, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration5 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration5 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration5 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration5').parents('.ch1_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
						.to($('.illustration5').parents('.ch1_stat').find('.txt-source'), { opacity: 1, yPercent: 0, duration: 0.5 }, '<')
						
					}
				});

			}



			if($('.article2_ch1').length > 0) {

				gsap.set('.illustration .i-base, .illustration .i-layer', {opacity: 0});
				
				gsap.set($('.illustration1').parents('.ch2_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration1",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					// once: true,
					animation: gsap.timeline()
							.to('.illustration1 .l1', { yPercent: -5, duration: 1 }, '<')
							.to('.illustration1 .l2, .illustration1 .l4', { yPercent: 5, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration1 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration1 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration1 .l4'), { opacity: 1, duration: 0.5 }, '<')
						.to($('.illustration1 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration1').parents('.ch2_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
					}
				});

				gsap.set($('.illustration2').parents('.ch2_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration2",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					animation: gsap.timeline().to($('.illustration2 .l2'), { yPercent: -10, duration: 1 })
							.to($('.illustration2 .l3'), { yPercent: 10, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration2 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration2 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration2 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration2').parents('.ch2_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
					}
				});

				gsap.set($('.illustration3').parents('.ch2_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration3",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					animation: gsap.timeline().to($('.illustration3 .l3'), { yPercent: -10, duration: 1 })
							.to($('.illustration3 .l2'), { yPercent: -6, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration3 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration3 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration3 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration3').parents('.ch2_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
						
					}
				});

				gsap.set($('.illustration4').parents('.ch2_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration4",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					animation: gsap.timeline().to($('.illustration4 .l2'), { yPercent: -10, duration: 1 })
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration4 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration4 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration4').parents('.ch2_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
					}
				});

				gsap.set($('.illustration5').parents('.ch2_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration5",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					animation: gsap.timeline().to($('.illustration5 .l3'), { yPercent: -15, duration: 1 })
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration5 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration5 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration5 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration5').parents('.ch2_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
						
					}
				});

			}


			if($('.article3_ch1').length > 0) {

				gsap.set('.illustration .i-base, .illustration .i-layer', {opacity: 0});
				
				gsap.set($('.illustration1').parents('.ch3_stat').find('.copy'), {opacity: 0, yPercent: 10});

				ScrollTrigger.create({
					trigger: ".illustration1",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					// once: true,
					animation: gsap.timeline()
							.to('.illustration1 .l4', { yPercent: -5, duration: 1 }, '<')
							.to('.illustration1 .l3', { yPercent: 5, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration1 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration1 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration1 .l4'), { opacity: 1, duration: 0.5 }, '<')
						.to($('.illustration1 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration1').parents('.ch3_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
					}
				});

				gsap.set($('.illustration2').parents('.ch3_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration2",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					animation: gsap.timeline().to($('.illustration2 .l3'), { yPercent: -10, duration: 1 })
							.to($('.illustration2 .l2'), { yPercent: 10, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration2 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration2 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration2 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration2').parents('.ch3_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
					}
				});

				gsap.set($('.illustration3').parents('.ch3_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration3",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					animation: gsap.timeline().to($('.illustration3 .l3'), { yPercent: -10, duration: 1 })
							.to($('.illustration3 .l4'), { yPercent: -6, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration3 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration3 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration3 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration3 .l4'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration3').parents('.ch3_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
						
					}
				});

				gsap.set($('.illustration4').parents('.ch3_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration4",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					animation: gsap.timeline().to($('.illustration4 .l3'), { yPercent: -10, duration: 1 })
								.to($('.illustration4 .l1'), { yPercent: 6, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration4 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration4 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration4 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration4 .l4'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration4').parents('.ch3_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
					}
				});


			}

			if($('.article4_ch1').length > 0) {

				gsap.set('.illustration .i-base, .illustration .i-layer', {opacity: 0});
				
				gsap.set($('.illustration1').parents('.ch4_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration1",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					// once: true,
					animation: gsap.timeline()
							.to('.illustration1 .l1', { yPercent: -5, duration: 1 })
							.to('.illustration1 .l3', { yPercent: 5, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration1 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration1 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration1 .l3'), { opacity: 1, duration: 0.5 }, '<')
						.to($('.illustration1').parents('.ch4_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
					}
				});

				gsap.set($('.illustration2').parents('.ch4_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration2",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					animation: gsap.timeline().to($('.illustration2 .l3'), { yPercent: -10, duration: 1 })
							.to($('.illustration2 .l2'), { yPercent: 10, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration2 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration2 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration2 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration2').parents('.ch4_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
					}
				});

				gsap.set($('.illustration3').parents('.ch4_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration3",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					animation: gsap.timeline().to($('.illustration3 .l3'), { yPercent: -10, duration: 1 })
							.to($('.illustration3 .l2'), { yPercent: -6, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration3 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration3 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration3 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration3').parents('.ch4_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
						
					}
				});

				gsap.set($('.illustration4').parents('.ch4_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration4",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					animation: gsap.timeline().to($('.illustration4 .l3'), { yPercent: -10, duration: 1 })
								.to($('.illustration4 .l1'), { yPercent: 6, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration4 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration4 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration4 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration4').parents('.ch4_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
					}
				});

				gsap.set($('.illustration5').parents('.ch4_stat').find('.copy'), {opacity: 0, yPercent: 10});
				ScrollTrigger.create({
					trigger: ".illustration5",
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					animation: gsap.timeline().to($('.illustration5 .l3'), { yPercent: -10, duration: 1 })
								.to($('.illustration5 .l2'), { yPercent: 6, duration: 1 }, '<')
					,
					onEnter: function(){
						gsap.timeline()
						.to($('.illustration5 .l1'), { opacity: 1, duration: 0.5 })
						.to($('.illustration5 .l2'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration5 .l3'), { opacity: 1, duration: 0.5 }, '-=50%')
						.to($('.illustration5').parents('.ch4_stat').find('.copy'), { opacity: 1, yPercent: 0, duration: 0.5 }, '-=50%')
					}
				});


			}

			$('.img-fullwith').each(function(){
				const elt = $(this);

				ScrollTrigger.create({
					trigger: elt,
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom 30px",
					onEnter: function(){
						gsap.timeline()
						.from(elt, { opacity: 0, yPercent: 10, duration: 0.5 })
						
					}
				});
			});

			// end CTA
			gsap.set('.end-cta .end-cta-title__title', { opacity: 0, yPercent: 10});
			gsap.set('.end-cta .end-cta-title__cta', { opacity: 0, yPercent: 5});
			ScrollTrigger.create({
				trigger: ".end-cta",
				scrub: true,
				// markers: true,
				start: "center bottom",
				end: "bottom 30px",
				onEnter: function(){
					gsap.timeline()
						.to('.end-cta .end-cta-title__title, .end-cta .end-cta-title__deadline', { opacity: 1, yPercent: 0, duration: 0.6 })
						.to('.end-cta .end-cta-title__cta', { opacity: 1, yPercent: 0, duration: 0.6 })
					
				}
			});

			// more
			$('.more-series').each(function(){
				var elts = $(this).find('.swiper-slide');
				gsap.set(elts, {y: 30, opacity: 0});

				ScrollTrigger.batch(elts, {
					// markers: true,
					start: "top 80%",
					onEnter: function(batch){  gsap.to(batch, {opacity: 1, y: 0, stagger: 0.2, overwrite: true})},
				});
			})
		},
		/**
		 * Sticky Section GENERIC
		 *
		 */
		heroBlur: function(){
			const self = this;

			ScrollTrigger.create({
				trigger: '.hero-logo',
				start: "bottom 30px",
				onEnter: function(){
					$('.logo-mini').addClass('is-visible');
				},
				onLeaveBack: function(){
					$('.logo-mini').removeClass('is-visible');
				}
				// end: "bottom bottom",
				// animation: gsap.to($(panel).find('img'), { y: '20%' })
			});

			// gsap.set(".bga-fixed-image", { filter: "blur(0px)", webkitFilter: "blur(0px)" });
			ScrollTrigger.create({
				trigger: '.hero',
				start: "top 30px",
				end: "bottom -50%",
				scrub: true,
				// markers: true,
				// animation: gsap.timeline().to('.bga-fixed-image', {filter:"blur(100px)", webkitFilter:"blur(100px)", duration: 1}).to('.bga-fixed-overlay', { opacity: '1', duration: 1 }, '<')
				animation: gsap.timeline()
								.to('#hue1feGaussianBlur', { attr:{stdDeviation:100} })
								.to('.bga-fixed-overlay', { opacity: 1 }, '<')
								.to('.bga-fixed', { scale: 1.1 }, '-=80%')
			});
		},


		serieStickyMenu: function(){
			
			$('.js-main-menu-toggle').on('click', function(){
				$('.js-main-menu-toggle').toggleClass('is-active');
				if($('.js-main-menu-toggle').hasClass('is-active')) {
					$('body').addClass('noscroll menu-open');

					if(!$('.cnn-header__row--gold').hasClass('cnn-header__row--sticky')) {
						$('.aside-more-series').addClass('is-at-top');
					}
					else {
						$('.aside-more-series').removeClass('is-at-top');
					}

					var listElts = '.article-list li'
					gsap.set(listElts, {y: 20, opacity: 0});

					gsap.timeline()
						.to('.article-list', {opacity: 1, duration: 0.9})
						.to(listElts , {y: 0, opacity: 1, stagger: 0.1, duration: 0.5})
				}
				else {
					$('body').removeClass('noscroll menu-open');
				}
			});
			$('.aside-more-series a, .aside-more-series-overlay').on('click', function(){
				$('.js-main-menu-toggle').removeClass('is-active');
				$('body').removeClass('noscroll menu-open');
			});

			// press excap key to close menu too
			$(document).keyup(function(e) {
				if (e.key === "Escape") { // escape key maps to keycode `27`
					if($('body').hasClass('menu-open')) {
						$('.js-main-menu-toggle').eq(0).trigger('click');
					}
				}
			});

			
		},

		sliderSwipper: function(){
			const swiper = new Swiper('.more-series__inner', {
				// Default parameters
				slidesPerView: "auto",
				spaceBetween: 0,
				freeMode: true,
				// keyboard: {
				// 	enabled: true,
				// 	onlyInViewport: false,
				// },
				// freeMode: {
				// 	enabled: true,
				// 	sticky: true,
				// },
				// scrollbar: {
				// 	el: '.swiper-scrollbar',
				// 	draggable: true,
				// },
				// simulateTouch: true,
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true,
				},
				// Responsive breakpoints
				// breakpoints: {
				// 	// when window width is >= 320px
				// 	320: {
				// 		slidesPerView: 1.5,
				// 	},
				// 	500: {
				// 		slidesPerView: 2.2,
				// 	},
				// 	768: {
				// 		slidesPerView: 3.1,
				// 	},
				// 	1024: {
				// 		slidesPerView: 3.5,
				// 	},
				// 	1300: {
				// 		slidesPerView: 4,
				// 	}
				// }
			})
		},

		navshare: function(){
			const self = this;
			// Setup social share menu
			var barEl = document.getElementById('cnn-header');
			var shareEl = barEl.querySelector('[data-share]');
			var shareToggleEl = barEl.querySelector('[data-share-toggle]');

			if(shareToggleEl) {
				shareToggleEl.addEventListener('click', function(){
					if(shareEl.classList.contains('cnn-header__share--active')){
						shareEl.classList.remove('cnn-header__share--active');
					} else {
						shareEl.classList.add('cnn-header__share--active');
					}
				}, false);
			}

			// Set up scroll handler
			document.addEventListener('scroll', function() {
				window.requestAnimationFrame(self.onScroll);
			}, {passive: true});

		},
		onScroll: function(){
			// Get current scroll position
			var sPos = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY;

			var barEl = document.getElementById('cnn-header');
			if(sPos < 30) {
				if($('.cnn-header__row--gold').hasClass('cnn-header__row--sticky')) {
					$('.cnn-header__row--gold').removeClass('cnn-header__row--sticky');
				}
			} else {
				// if(!barEl.classList.contains('cnn-header--fixed')) {
				// 	barEl.classList.add('cnn-header--fixed');
				// }
				if(!$('.cnn-header__row--gold').hasClass('cnn-header__row--sticky')) {
					$('.cnn-header__row--gold').addClass('cnn-header__row--sticky');
				}
			}
		},


		/**
		 * Scroll to
		 *
		 */
		scrollToAnchor: function () {
			// const ft_nav_height = $('#ft-fixed-nav-height').height();

			$('body').on('click', '.scrollTo', function(event){
				event.preventDefault();
				event.stopPropagation();

				var tag = $(this).attr('href');

				$('html,body').animate({scrollTop: $(tag).offset().top },'slow');
			});
		},

		/**
		 * Open links in new window
		 *
		 */
		newWindowLink: function () {

			$('p a[href]').not('.goto').each(function() {

				// if(!$(this).attr('href').indexOf('cnn') != -1) {
					$(this).attr('target','_blank');
				// }
			});
		},

		/**
		 * Image lazy sizes
		 *
		 */
		lazySizes: function(){
			handleLazySizes( this.onImageLoaded.bind(this) );
		},
	
	};


	$(document).ready( function(){
		Site.init();
	})

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/main.js